<template>
    <div class="event__list_select_update">
        <div class="event__list_select_update_header">
            <view-actions
                :title="$t('ebs.events.list.title.selectEvent')"
                :cancel-button-active="false"
                :submit-button-text="$t('ebs.events.list.buttons.buttonCreateEvent')"
                :action-button-visibility="['event_coordinator']"
                @emit-submit="createEvent"
            />
        </div>
        <div class="event__list_select_update_main">
            <component-list
                :filter-search-queryable="true"
                :component-table="EventListSelectUpdateTable"
                :item-name="['event', 'events']"
                :filter-search-placeholder="$t('ebs.events.list.labels.searchEvents')"
                :get-pagination-getter="'getEventsPagination'"
                :get-items-getter="'getEvents'"
                :get-items-dispatch="'getEvents'"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import EventListSelectUpdateTable from '@/components/ebs/events/list/EventListSelectUpdateTable'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'event-list-select-update',
  components: {
    ComponentList,
    ViewActions
  },
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      outputItems: [],
      EventListSelectUpdateTable
    }
  },
  methods: {
    createEvent () {
      this.$router.push({ name: 'ebs-event-add', query: { courseId: this.$route.params.courseId } })
    },
    setFilterResult (data) {
      this.outputItems = data
    },
    switchListView (value) {
      this.listView = value
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/events/eventlistselectupdate";
</style>
